import React from 'react';
import PropTypes from 'prop-types';
import { Hint } from '../KeyComponents';

function DropdownHint({ children, state }) {
  return (
    <Hint
      icon="ri-information-fill"
      disabled={state === 'disabled'}
      error={state === 'error'}
    >{children}
    </Hint>
  );
}

DropdownHint.propTypes = {
  children: PropTypes.node,
  state: PropTypes.oneOf(['default', 'disabled', 'error']),
};

DropdownHint.defaultProps = {
  state: 'default',
  children: null,
};

export default DropdownHint;
